<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="二维码邀请"
    width="500px"
  >
    <div style="text-align:center">
      <img src="../../../assets/image/erweima.png" style="width:300px"></img>
      <p style="text-align:center">微信扫码邀请面试</p>
    </div>

  </el-dialog>
</template>

<script>
import { importAudit} from "@/api/director/interview/index";

export default {
  components: { },

  data() {
    return {
      visible: false,
      formData: {
        project_id:'',
        job_id:'',
        user_app_id:"",
        lat:"",
        lng:"",
        address: "",
        audit_at: "",
        person_name: "",
        person_phone: "",
        mark:''
       
      },
       
    };
  },

 
  mounted() {

},
destroyed(){
  this.handleClose();
},
  
  methods: {
    handleClose() {
      this.visible = false;
      this.$refs["form"].resetFields();

    },


    init() {
      this.visible = true;

    },

    
    
  },

 
};
</script>

<style lang="scss" scoped>
::v-deep .myWindow {
    border-radius: 15px;



.el-button--primary {
  color: #FFF;
  background-color: #717ebb;
  border-color: #717ebb;
}


/*
.footer{
  display: flex;
  justify-content: center;
}*/


  }
</style>
